import { render, staticRenderFns } from "./OfferDetailProduct.vue?vue&type=template&id=2b439aa8"
import script from "./OfferDetailProduct.vue?vue&type=script&lang=js"
export * from "./OfferDetailProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports